/**
 * useraction
 */

const useraction = () => import('@/module/index/pages/register/useraction.vue')
const register = () => import('@/module/index/pages/register/register.vue')
const registersuccess = () => import('@/module/index/pages/register/registersuccess.vue')
const userlogin = () => import('@/module/index/pages/login/login.vue')
const userlogin1 = () => import('@/module/index/pages/login/login1.vue')
// const stafflogin = () => import('@/module/index/pages/login/loginstaff.vue')
const findpwd = () => import('@/module/index/pages/login/findpwd.vue')
const comp_404 = () => import('@/module/index/pages/register/404.vue')

export default {
  path: '/useraction',
  component: useraction,
  redirect: '/useraction/register',
  children: [{
    path: '/useraction/register',
    component: register
  }, {
    path: '/useraction/register-success',
    component: registersuccess,
    meta: {
      title: '',
      requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      isback: false
    }
  }, {
    path: '/useraction/login',
    component: userlogin
  }, {
    path: '/useraction/login1',
    component: userlogin1
  },
    // {
    // 	path: '/useraction/stafflogin',
    // 	component: stafflogin
    // },
  {
    path: '/useraction/findpwd',
    component: findpwd
  }, {
    path: '/useraction/404',
    component: comp_404
  }

  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/useraction.js